import { apiClient } from '@/lib/api-client';
import type { ApiResponse, PaginatedResponse, User, UserOrgMembership, CreateUserRequest, UpdateUserRequest, ResetPasswordRequest } from '@/types/api';

export async function getUsers(params?: {
  search?: string;
  role?: string;
  status?: string;
  page?: number;
  perPage?: number;
  orgId?: string;
}): Promise<PaginatedResponse<User>> {
  const { orgId, ...queryParams } = params ?? {};
  const response = await apiClient.get<PaginatedResponse<User>>('/users', {
    params: queryParams,
    ...(orgId ? { headers: { 'X-Active-Org-Id': orgId } } : {}),
  });
  return response.data;
}

export async function createUser(data: CreateUserRequest): Promise<ApiResponse<User>> {
  const response = await apiClient.post<ApiResponse<User>>('/users', data);
  return response.data;
}

export async function updateUser(id: string, data: UpdateUserRequest): Promise<ApiResponse<null>> {
  const response = await apiClient.put<ApiResponse<null>>(`/users/${id}`, data);
  return response.data;
}

export async function deleteUser(id: string): Promise<ApiResponse<null>> {
  const response = await apiClient.delete<ApiResponse<null>>(`/users/${id}`);
  return response.data;
}

export async function resetUserPassword(id: string, data: ResetPasswordRequest): Promise<ApiResponse<null>> {
  const response = await apiClient.post<ApiResponse<null>>(`/users/${id}/reset-password`, data);
  return response.data;
}

export async function getUserById(id: string): Promise<User> {
  const response = await apiClient.get<ApiResponse<User>>(`/users/${id}`);
  return response.data.data!;
}

export async function getUserOrganizations(id: string): Promise<UserOrgMembership[]> {
  const response = await apiClient.get<ApiResponse<UserOrgMembership[]>>(`/users/${id}/organizations`);
  return response.data.data ?? [];
}
